// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store';

/* 路由 */
import router from './router'

// 组件
import ElementUI from 'element-ui';
import '@/styles/element-ui.css'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/swiper-bundle.min.css';


/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min.js'

/* animate.css */
import 'animate.css'

/* imagehover.css */
import 'imagehover.css/css/imagehover.css'

/* video.js */
import 'video.js/dist/video-js.css'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

/*返回上一页*/
import GoBack from './components/GoBack'
Vue.component(GoBack.name,GoBack)

// 额外字段弹窗
import DialogExtraFields from './components/DialogExtraFields'
Vue.component(DialogExtraFields.name,DialogExtraFields)

// 签名弹窗
import SignaturePad from './components/SignaturePad'
Vue.component(SignaturePad.name,SignaturePad)

//个人简历
import PersonResume from './components/PersonResume'
Vue.component(PersonResume.name,PersonResume)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})


new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js